import {createBodyClickListener, createModalBodyClickListener} from './body-click-listener'

function modalBodyClickListener(context, value){
    var self = this;
    return createModalBodyClickListener(
        (e) => {
            let isOpen = !!context[value];
            let outsideClick = isOpen && e.target.className === 'modal-wrapper';
            if (outsideClick) {
                if (e.which !== 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                } else {
                    context[value] = false;
                    e.stopPropagation()
                }
            }else{
                if (e.which === 27) {
                    context[value] = false;
                }
            }
        }
    )
}

function elementBodyClickListener(context, element, value){
    let self = this;
    return createBodyClickListener(
        (e) => {
            let isOpen = !!context[value];
            let outsideClick = isOpen && !context.$refs[element].contains(e.target);

            if (outsideClick) {
                if (e.which !== 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                } else {
                    context[value] = false;
                    //e.stopPropagation()
                }
            } else {
                context[value] = false
            }
        }
    )
}

function inputBodyClickListener(context, element, value){
    let self = this;
    return createBodyClickListener(
        (e) => {
            let isOpen = !!context[value];
            let outsideClick = isOpen && !context.$refs[element].contains(e.target);

            if (outsideClick) {
                if (e.which !== 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                } else {
                    context[value] = false;
                    //e.stopPropagation()
                }
            } else {
                if (e.which === 27) {
                    context[value] = false;
                }
            }
        }
    )
}

export { modalBodyClickListener, elementBodyClickListener, inputBodyClickListener};
